module.exports = __webpack_public_path__ + "img/backpac.11d1aab1.svg";